import React from 'react';
import { NewUsers } from '../types';

interface Props {
  data: NewUsers;
}

export const NewUsersCard: React.FC<Props> = ({ data }) => {
  const periods = [
    { label: '30 days', value: data.last_30_days },
    { label: '60 days', value: data.last_60_days },
    { label: '90 days', value: data.last_90_days },
  ];

  const maxVal = Math.max(data.last_30_days, data.last_60_days, data.last_90_days, 1);

  return (
    <div style={{ border: '1px solid #e5e7eb', borderRadius: 12, padding: 24 }}>
      <span style={{ fontSize: 13, fontWeight: 500, color: '#6b7280', display: 'block', marginBottom: 20 }}>
        New Users
      </span>

      <div style={{ marginBottom: 4 }}>
        <span style={{ fontSize: 32, fontWeight: 600, color: '#111827', fontVariantNumeric: 'tabular-nums' }}>
          {data.last_30_days}
        </span>
      </div>
      <p style={{ fontSize: 12, color: '#6B7280', margin: '0 0 20px' }}>added in last 30 days</p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {periods.map((p, index) => {
          const pct = (p.value / maxVal) * 100;
          const isFirst = index === 0;
          return (
            <div key={p.label}>
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, marginBottom: 4 }}>
                <span style={{ color: isFirst ? '#374151' : '#6B7280' }}>Last {p.label}</span>
                <span style={{ fontVariantNumeric: 'tabular-nums', fontWeight: isFirst ? 600 : 400, color: isFirst ? '#374151' : '#6B7280' }}>
                  {p.value}
                </span>
              </div>
              <div style={{ width: '100%', backgroundColor: '#f3f4f6', borderRadius: 99, height: 6 }}>
                <div
                  style={{
                    height: 6, borderRadius: 99,
                    width: `${pct}%`,
                    backgroundColor: isFirst ? '#22c55e' : '#bbf7d0',
                    transition: 'width 0.3s ease',
                  }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
